import { render, staticRenderFns } from "./CardsProductsTextil.vue?vue&type=template&id=588840f3&scoped=true&"
import script from "./CardsProductsTextil.vue?vue&type=script&lang=js&"
export * from "./CardsProductsTextil.vue?vue&type=script&lang=js&"
import style0 from "./CardsProductsTextil.vue?vue&type=style&index=0&id=588840f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588840f3",
  null
  
)

export default component.exports